/**
 * Module: UI
 * Mobile Navigation, Sticky Header, Widgets
 */

export default (el) => {
    // 1. Mobile Menu Logic
    const menuBtn = document.getElementById('menu-btn');
    const navLinks = document.getElementById('nav-links');
    const overlay = document.getElementById('overlay');
    const closeBtn = document.getElementById('mobile-nav-close');
    
    if (menuBtn && navLinks) {
        const openMenu = () => {
            navLinks.classList.add('active');
            menuBtn.classList.add('active');
            overlay?.classList.add('active');
            document.body.classList.add('menu-open');
        };
        
        const closeMenu = () => {
            navLinks.classList.remove('active');
            menuBtn.classList.remove('active');
            overlay?.classList.remove('active');
            document.body.classList.remove('menu-open');
        };
        
        menuBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (navLinks.classList.contains('active')) closeMenu();
            else openMenu();
        });
        
        closeBtn?.addEventListener('click', (e) => {
            e.preventDefault();
            closeMenu();
        });

        overlay?.addEventListener('click', (e) => {
            e.preventDefault();
            closeMenu();
        });

        // Close on ESC
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && navLinks.classList.contains('active')) closeMenu();
        });
    }

    // 2. Messenger/WhatsApp Widget Logic
    const messengerToggle = el.querySelector('[id$="-toggle"], [id$="-toggle-btn"]');
    const messengerPanel = el.querySelector('[id$="-panel"]');
    const messengerClose = el.querySelector('[id$="-close-btn"], #whatsapp-close-btn');
    
    if (messengerToggle && messengerPanel) {
        const toggle = (e) => {
            if (e) e.preventDefault();
            messengerPanel.classList.toggle('active');
        };
        messengerToggle.addEventListener('click', toggle);
        messengerClose?.addEventListener('click', toggle);
    }

    // 3. Header Scroll Effect
    const header = document.querySelector('header');
    if (header) {
        window.addEventListener('scroll', () => {
            header.classList.toggle('scrolled', window.scrollY > 50);
        }, { passive: true });
    }

    // 4. Counter Animations (Intersection Observer)
    const counters = document.querySelectorAll('.count-up');
    if (counters.length > 0) {
        const animateCounter = (counter) => {
            const target = +counter.getAttribute('data-target');
            const duration = 2000;
            const startTime = performance.now();
            
            const update = (now) => {
                const elapsed = now - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easedProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
                counter.innerText = Math.floor(easedProgress * target);
                
                if (progress < 1) requestAnimationFrame(update);
                else counter.innerText = target;
            };
            requestAnimationFrame(update);
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    animateCounter(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });

        counters.forEach(c => observer.observe(c));
    }

    // 5. Reading Progress Bar
    const progressBar = document.querySelector('[id^="reading-progress"]');
    if (progressBar) {
        window.addEventListener('scroll', () => {
            const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const scrolled = (winScroll / height) * 100;
            progressBar.style.width = scrolled + "%";
        }, { passive: true });
    }

    // 6. Map Lazy Loader (replaces inline onclick)
    document.querySelectorAll('[data-map-loader]').forEach(container => {
        container.addEventListener('click', function handler() {
            const iframe = document.createElement('iframe');
            iframe.src = this.dataset.embed;
            iframe.title = this.dataset.title;
            iframe.width = '100%';
            iframe.height = '100%';
            iframe.style.border = '0';
            iframe.loading = 'lazy';
            iframe.classList.add('animate-fade-in');
            this.innerHTML = '';
            this.appendChild(iframe);
            this.removeEventListener('click', handler);
            
            // Dispatch event for analytics
            document.body.dispatchEvent(new CustomEvent('map_loaded', { 
                detail: { title: this.dataset.title } 
            }));
        });
    });
    
    // 7. Mobile Submenu Toggles
    const submenuTriggers = document.querySelectorAll('.mobile-submenu-trigger');
    submenuTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            const submenuId = trigger.getAttribute('data-submenu');
            const submenu = document.getElementById(submenuId);
            const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
            
            trigger.setAttribute('aria-expanded', !isExpanded);
            
            if (submenu) {
                submenu.classList.toggle('hidden');
                submenu.classList.toggle('animate-fade-in');
            }
            
            // Rotate chevron
            const chevron = trigger.querySelector('svg');
            if (chevron) {
                chevron.style.transform = isExpanded ? 'rotate(0deg)' : 'rotate(180deg)';
                chevron.style.transition = 'transform 0.3s ease';
            }
        });
    });
};
